import React, { useEffect, useState, useRef } from 'react';
import {Link, useNavigate} from 'react-router-dom'

import Header from '../components/Header';
import QRCode from 'qrcode.react';
import ReactPDF, { Document, Page, Text, View, StyleSheet, Image,PDFDownloadLink } from '@react-pdf/renderer';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import Footer from '../components/Footer';

function FundraiserCompletion(props) {
  const [paymentIntentId, setPaymentIntent] = useState("");
  const [data, setData] = useState([]);
  const [seats, setSeats] = useState();
  const [event, setEvent] = useState(null);
  const [pic, setPic] = useState("");
  const [imageUrls, setImageUrls] = useState([]);
  const divRef = useRef(null);
const [load,setLoad] = useState(false)
  console.log("DATA", data);
  console.log("PIC", pic);

  console.log(imageUrls);

const navigate = useNavigate()

  const [id, setId] = useState(null);
  const [amount, setAmount] = useState(null);

  useEffect(() => {

    const queryString = window.location.search;
    // Create a URLSearchParams object
    const urlParams = new URLSearchParams(queryString);

    // Retrieve the 'id' and 'amount' parameters
    // const id = urlParams.get('id');
    const amount = urlParams.get('amount');
    const email = urlParams.get('email');
    const name = urlParams.get('name');
    const phone = urlParams.get('phone');


    fetch('/addFundraiser', {
      method: "post",
      headers: {
        Authorization: "Bearer " +localStorage.getItem("jwt"),
        "Content-Type":"application/json"
      },
      body: JSON.stringify({
        amount:amount,email,name,phone
        
      })
    })
      .then(res => res.json())
      .then(results => {

        navigate('/fundcomplationcard')
        // setData(results.tickets);
        // setEvent(results.event);
        // setPic(results.event.pic);
        // setSeats(results.seats)
        // // setLoad(true)
     
      });
  }, []);

  // if(load){
  //   handleConvertToPdf()
  //   setLoad(false)
  // }


  const sendPdfToBackend = (pdfData) => {
    // Assuming you have a server endpoint that accepts file uploads using Multer
    // const backendEndpoint = '/upload-pdf';
  console.log("POSTT")
    // Create a FormData object and append the PDF data
    // const formData = new FormData();
    // formData.append('pdf', pdfData);
  
    // Make a POST request to the server
    fetch("/upload-pdf", {
      method: 'POST',
      body:  JSON.stringify({ pdfData }),
    })
      .then((response) => response.json())
      .then((data) => {
        // Handle the response from the server (e.g., display a success message)
        console.log('Server response:', data);
      })
      .catch((error) => {
        // Handle errors
        console.error('Error sending PDF to the server:', error);
      });
  };
  return (
    <>
      <Header></Header>
   
{/* <p class="mb-0 text-center text-3xl font-extrabold text-purple-500 ">
                      Thank You
                  </p>
      <div   className="bg-gray-50 flex items-center justify-center px-5 py-5">
        <div ref={divRef} className="grid relative grid-cols-1 gap-6 md:grid-cols-1 xl:grid-cols-1">

        <div class="flex items-center justify-between w-64 p-4 bg-white shadow-lg rounded-2xl mb-5">
    <div class="w-2/6">
        <img src="/logo.png" alt="person" class="w-12 h-12 rounded-full"/>
    </div>
    <div class="w-3/6">
        <p class="text-sm text-gray-500">
            We will mail you the movie links 
            
        </p>
    </div>
    <div class="w-1/6 text-right">
        <svg width="20" height="20" fill="currentColor" viewBox="0 0 1792 1792" class="w-6 h-6 text-indigo-500" xmlns="http://www.w3.org/2000/svg">
            <path d="M1792 710v794q0 66-47 113t-113 47h-1472q-66 0-113-47t-47-113v-794q44 49 101 87 362 246 497 345 57 42 92.5 65.5t94.5 48 110 24.5h2q51 0 110-24.5t94.5-48 92.5-65.5q170-123 498-345 57-39 100-87zm0-294q0 79-49 151t-122 123q-376 261-468 325-10 7-42.5 30.5t-54 38-52 32.5-57.5 27-50 9h-2q-23 0-50-9t-57.5-27-52-32.5-54-38-42.5-30.5q-91-64-262-182.5t-205-142.5q-62-42-117-115.5t-55-136.5q0-78 41.5-130t118.5-52h1472q65 0 112.5 47t47.5 113z">
            </path>
        </svg>
    </div>
</div>




      


          
        </div>
      </div>
       */}

            <div>
                Processing....
            </div>


            {/* {handleConvertToPdf()} */}
            <Footer></Footer>
    </>
  );
}

export default FundraiserCompletion;
